import React, { FunctionComponent } from "react";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
} from "@fluentui/react";

export interface IDialogComponent {
  isOpenModal: boolean;
  closeModal: () => void;
  title: string;
  description: string;
  yesButtonLabel: string;
  noButtonLabel: string;
  onClickYes: () => void;
  onClickNo: () => void;
}

export const DialogComponent: FunctionComponent<IDialogComponent> = (props) => {
  const { isOpenModal, title, description, closeModal, onClickYes, onClickNo, yesButtonLabel, noButtonLabel } = props;
  return (
    <Dialog
      hidden={!isOpenModal}
      dialogContentProps={{
        type: DialogType.normal,
        title: `${title}`,
        subText: `${description}`,
      }}
      modalProps={{
        isBlocking: false,
      }}
    >
      <DialogFooter>
        <PrimaryButton
          text={yesButtonLabel}
          onClick={() => {
            onClickYes();
            closeModal();
          }}
        />
        <DefaultButton
          text={noButtonLabel}
          onClick={() => {
            onClickNo();
          }}
        />
      </DialogFooter>
    </Dialog>
  );
};
